import { Box, Chip } from "@mui/material";
import { Dot, Flex } from "@zfp-akademie-a-s/zfp-design";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { getCzechPluralForm } from "Infrastructure/Utils/LanguageUtils";
import type { FC } from "react";

type Props = {
  readonly count: number;
};

export const FormDrawerUnsavedBadge: FC<Props> = ({ count }) => {
  const { t } = useResource();

  return (
    <Chip
      color="primary"
      size="small"
      icon={
        // the chip sizes its icon slot; the dot keeps its own 8px in the middle of it
        <Flex component="span" alignItems="center" justifyContent="center">
          <Dot size="lg" color="primary.main" pulse />
        </Flex>
      }
      label={
        <>
          <Box component="strong" fontWeight={700}>
            {count}
          </Box>{" "}
          {t(
            getCzechPluralForm(count, {
              one: Resources.Common.UnsavedChanges_one,
              few: Resources.Common.UnsavedChanges_few,
              other: Resources.Common.UnsavedChanges_other,
            }),
          )}
        </>
      }
    />
  );
};
